/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { FooterLandAck } from "./footer-land-ack";
import { FooterMain } from "./footer-main";
import { FooterCopyright } from "./footer-copyright";

const Footer = () => {
    return (
        <div className="footer">
            <FooterLandAck />
            <FooterMain />
            <FooterCopyright />
        </div>
    );
};

export { Footer };
